export const STATUS_TONE = {
  new: "bg-blue-100 text-blue-700",
  contacted: "bg-indigo-100 text-indigo-700",
  qualified: "bg-teal-100 text-teal-700",
  converted: "bg-teal-100 text-teal-700",
  touring: "bg-amber-100 text-amber-700",
  signed: "bg-emerald-100 text-emerald-700",
  lost: "bg-slate-100 text-slate-600",
};

// Friendly pipeline buckets shown to partners (qualified + converted = Searching)
export const PIPELINE_BUCKETS = [
  { key: "refer", label: "Refer", statuses: ["new"] },
  { key: "connect", label: "Connect", statuses: ["contacted"] },
  { key: "search", label: "Search", statuses: ["qualified", "converted"] },
  { key: "tour", label: "Tour & Apply", statuses: ["touring"] },
  { key: "movein", label: "Move In", statuses: ["signed"] },
  { key: "closed", label: "Closed", statuses: ["lost"] },
];

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" }) : "—");
export const fmtBudget = (b) => (b ? `$${Number(b).toLocaleString()}/mo` : "—");
